import React from "react";
import Movie from "./Component/movie";
import "./App.css";

const App = () => {
  return (
    <div className="App">
      <Movie />
    </div>
  );
};

export default App;
